import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockImageVideoFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const imageVideoBlockConfig = {
  name: 'outer-block-image-video',
  component: defineAsyncComponent(() => import('./CmsImageVideoBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./ImageVideoBlock.vue')),
  fields: blockImageVideoFields,
} satisfies ModularBlockConfig;
